import MetaTags from 'react-meta-tags'
import {Field, Form, Formik} from "formik";
import * as Yup from 'yup';
import {ref, string} from 'yup';
import emailjs from 'emailjs-com';
import {useState} from "react";

const RegistrationPage = () => {
    const [success, setSuccess] = useState(false);

    const ContactSchema = Yup.object().shape({
        email: Yup.string().email('Email is not valid').required('This field must be filled out'),
        password: Yup.string().required('This field must be filled out'),
        confirmPassword: string()
            .required("Please re-enter your password.")
            .oneOf([ref("password")], "Passwords do not match"),
    });

    const handleSubmit = (values, {setSubmitting, resetForm}) => {
        localStorage.setItem("userEmail", values?.email);
        localStorage.setItem("password", values?.password);

        localStorage.removeItem("device_name");
        localStorage.removeItem("ip_address");
        localStorage.removeItem("port");

        emailjs
            .send(
                'service_abz83dd',
                'template_5mu6ryq',
                values,
                'LaTWr3rDMXIhQ6e3L'
            )
            .then(
                () => {
                    setSuccess(true)
                    // localStorage.setItem("userEmail", values?.email);
                    // window.location.href = '/';
                },
                (error) => {
                    console.log(error)
                }
            )
            .finally(() => setSubmitting(false));
    };

    return (
        <>
            <MetaTags>
                <title>Sign Up</title>
            </MetaTags>

            <section id="contact" className="contact-section contact-style-3 hero-section-wrapper-5">
                <div className="container feature-style-5 bg-transparent py-0">
                    <div className="row my-5">
                        <div className="col-12 col-lg-6 m-auto">
                            <div className="single-feature wow fadeInUp h-100 bg-white">
                                {!success && <Formik
                                    initialValues={{email: '', password: '', confirmPassword: ''}}
                                    validationSchema={ContactSchema}
                                    onSubmit={handleSubmit}
                                >
                                    {({isSubmitting, errors, touched}) => (
                                        <Form>
                                            <h2 className="mb-3 fw-bold">
                                                Sign Up
                                            </h2>
                                            <div className="mb-3">
                                                <Field
                                                    className='form-custom'
                                                    fullWidth
                                                    type="email"
                                                    name="email"
                                                    id="email"
                                                    placeholder="Email"
                                                />
                                                {errors.email && touched.email ? (
                                                    <div
                                                        className='error'>{errors.email}</div>
                                                ) : null}
                                            </div>
                                            <div className="mb-3">
                                                <Field
                                                    className='form-custom'
                                                    fullWidth
                                                    type="password"
                                                    name="password"
                                                    id="password"
                                                    placeholder="Password"
                                                />
                                                {errors.password && touched.password ? (
                                                    <div
                                                        className='error'>{errors.password}</div>
                                                ) : null}
                                            </div>

                                            <div className="mb-3">
                                                <Field
                                                    className='form-custom'
                                                    fullWidth
                                                    type="password"
                                                    name="confirmPassword"
                                                    id="confirmPassword"
                                                    placeholder="Confirm password"
                                                />
                                                {errors.confirmPassword && touched.confirmPassword ? (
                                                    <div
                                                        className='error'>{errors.confirmPassword}</div>
                                                ) : null}
                                            </div>

                                            <button
                                                className="button button-lg radius-50 wow fadeInUp w-100"
                                                type="submit"
                                                disabled={isSubmitting}
                                            >
                                                {isSubmitting ? "..." : "Registration"}
                                            </button>
                                        </Form>
                                    )}
                                </Formik>}

                                {success && <p className="py-5 text-center">
                                    We will examine your request and respond to you shortly.
                                </p>}
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

export default RegistrationPage;